export const projects = [
    { value: 'project1', label: 'Project 1' },
    { value: 'project2', label: 'Project 2' },
    { value: 'project3', label: 'Project 3' },
];

export const measurements = [
    { value: 'measurement1', label: 'Measurement 1' },
    { value: 'measurement2', label: 'Measurement 2' },
    { value: 'measurement3', label: 'Measurement 3' },
];

export const charts = [
    { value: 'line', label: 'Line Chart' },
    { value: 'bar', label: 'Bar Chart' },
    { value: 'pie', label: 'Pie Chart' },

];

